import CompanyCard from '@/components/CompanyCard'
import CurrencyFilter from '@/common/currency.filter'
import Vue from 'vue'
import appConfig from '@/config.js'
import { fleetRentalOrderStatuses } from '@/common/quickFiltersDefinitions/fleet-rental-orders'

const ListItemDateTime = () => import('@/components/Engine/ListItemDateTime')
const FleetListItemAmountRequested = () => import(/* webpackChunkName: "tours" */ '@/components/Fleet/ListItemAmountRequested')

const fleetRentalOrdersModel = vm => ({
  title: vm.$gettext('Fleet Rental Orders'),
  endpoint: 'fleet-rental-orders',
  allowNew: true,
  countrize: 'company.country_iso_code',
  // Layout declarativo del form de edición (MOOV-5200, opt-in con fallback
  // plano): datos y precios lado a lado, el resto full-width al final
  editLayout: [
    { row: [{ span: 12, keys: ['id', 'company_id', 'reference'] }] },
    {
      row: [
        { span: { cols: 12, md: 6 }, keys: ['agreed_price', 'price', 'currency'] },
        { span: { cols: 12, md: 6 }, keys: ['date_from', 'date_to', 'amount_requested'] }
      ]
    }
  ],
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'company_id',
      sortable: true,
      editable: true,
      required: true,
      label: vm.$gettext('Company'),
      formatter: (value, key, item) => {
        return new Vue({
          ...CompanyCard,
          parent: this,
          propsData: {
            company: item.company,
            profilePicture: false,
            withTitles: false,
            withContact: false
          }
        }).$mount().$el.outerHTML
      }
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      sortable: false,
      editable: true,
      required: false,
      description: vm.$gettext('Rental order text reference')
    },
    {
      key: 'agreed_price',
      label: vm.$gettext('Agreed Price'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Original agreed price with the company which requests the rental order'),
      formatter: (value, key, item) => {
        return CurrencyFilter(value, item.currency)
      }
    },
    {
      key: 'price',
      label: vm.$gettext('Price'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Price that the company ends up paying'),
      formatter: (value, key, item) => {
        return CurrencyFilter(value, item.currency)
      }
    },
    {
      key: 'currency',
      label: vm.$gettext('Currency'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Currency for the rental order price')
    },
    {
      key: 'date_from',
      label: vm.$gettext('From Date'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Date since the rental applies'),
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'date_to',
      label: vm.$gettext('To Date'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Date until the rental applies'),
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'amount_requested',
      label: vm.$gettext('Amount Requested'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext('Amount of vehicles requested'),
      component: (value, key, item, row) => ({
        is: FleetListItemAmountRequested,
        props: { value, item, rowIndex: row.index }
      })
    },
    {
      key: 'place_id',
      label: vm.$gettext('Place ID'),
      sortable: false,
      editable: true,
      required: false,
      description: vm.$gettext('Place ID, where the fleet must be')
    },
    {
      key: 'place',
      label: vm.$gettext('Address'),
      sortable: false,
      editable: true,
      required: false,
      formatter: (value, key, item) => {
        return (
          '<span class="shipping-address-listings" title="' +
          (item.place ? item.place.formatted_address : '-') +
          '">' +
          (item.place ? item.place.formatted_address : '-') +
          '</span>'
        )
      }
    },
    {
      key: 'instructions',
      label: vm.$gettext('Instructions'),
      sortable: false,
      editable: true,
      required: false,
      description: vm.$gettext('Additional information'),
      filter: 'brize'
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      sortable: true,
      editable: true,
      required: false,
      description: vm.$gettext('Current status [ pending, confirmed, finished, canceled ]'),
      formatter: value => {
        const status = fleetRentalOrderStatuses(vm).find(x => x.value === value)
        return status ? '<div class="text-' + status.variant + '">' + status.text + '</div>' : value
      }
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Clone'),
      type: 'button',
      icon: ['far', 'copy'],
      title: vm.$gettext('Clone this Order'),
      variant: 'dark',
      position: 'start',
      disabledCondition: item => {
        return false
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to CLONE this Fleet Rental Order?'))) {
          Vue.http.post(appConfig.api.baseUrl + 'fleet-rental-orders/' + item.id + '/clone').then(response => {
            setTimeout(() => {
              vm.$root.$emit('bv::refresh::table', 'apiListTable')
            }, 100)
          })
        }
      }
    }
  ],
  includes: [
    'company.country',
    'fleet_rental_order_vehicles.courier.account',
    'fleet_rental_order_vehicles.vehicle.vehicle_type',
    'fleet_rental_order_vehicles.place',
    'fleet_rental_order_vehicles.status_history',
    'place'
  ],
  filters: ['id', 'company_id', 'company.country_iso_code', 'reference'],
  exclude: ['place_id', 'currency']
})

export default fleetRentalOrdersModel
